export default "__VITE_ASSET__63cef9ac__"